import React from 'react'

const PlaceholderOption = React.forwardRef(({ label }, ref) => (
  <div
    ref={ref}
    style={{
      textAlign: 'center',
      padding: '10px',
      border: '1px solid #ccc',
      borderRadius: '5px',
      color: '#6c757d',
      pointerEvents: 'none',
      userSelect: 'none',
    }}
  >
    {label}
  </div>
))

export default PlaceholderOption